import type { JSX } from "react";

import { Select, Text } from "@mantine/core";

import type { PartnerProgram } from "@/shared-types";

import { useCustomerProgram } from "@/customer-info";

import classes from "./CustomerProgramSelection.module.css";

export interface CustomerProgramSelectionProps {
    programs: PartnerProgram[];
}

export function CustomerProgramSelection({ programs }: CustomerProgramSelectionProps): JSX.Element {
    const { customerProgram, setCustomerProgram } = useCustomerProgram();

    const programList: string[] = programs.map((program) => program.name);

    const findAndSetProgram = (programName: string | null) => {
        const program = programs.find((pgm) => pgm.name === programName);
        if (program) {
            setCustomerProgram(program);
        }
    };
    const handleOptionSelect = (value: string | null) => {
        findAndSetProgram(value);
    };

    return (
        <>
            <Text c="dark.1" size="sm" mb="md" mt="xxl">
                What plan does the customer have?
            </Text>
            <Select
                allowDeselect={false}
                radius="xs"
                fz="xs"
                placeholder="Choose a program"
                classNames={{
                    input: classes.styledInput,
                    options: classes.optionsWrapper,
                    option: classes.option,
                    dropdown: classes.dropdown,
                }}
                comboboxProps={{ withinPortal: false }}
                size="md"
                data={programList}
                onChange={(_value) => handleOptionSelect(_value)}
                value={customerProgram?.name}
                withCheckIcon={false}
            />
        </>
    );
}
